module.exports = __webpack_public_path__ + "img/logo-nombre-morado.369cee70.png";